<template>
  <div>
    <div class="bg">
      <v-container>
        <v-row>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="text-center topheading">
            <h1 class="mb-0 white--text">
              <v-icon size="40" color="white" class="mr-2">mdi-facebook</v-icon
              >Facebook Competitive Analysis
            </h1>
          </v-col>
          <v-col cols="2">
            <!-- <v-btn
              v-if="this.packageType === 'Compeat Demo Subscription'"
              rounded
              small
              class="secondary"
              @click="checkUser()"
              >Purchase Now</v-btn
            > -->
          </v-col>
          <v-col cols="12">
            <v-card flat class="px-3 py-3">
              <v-row align="center">
                <v-col cols="2">
                  <v-tooltip v-if="isLoggedInUser" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="backToSubscription()"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        dense
                        icon
                      >
                        <v-icon>mdi-arrow-left-bold-circle</v-icon>
                      </v-btn>
                    </template>
                    <span>Back To Subscription</span>
                  </v-tooltip>
                </v-col>
                <v-col cols="8" class="text-center pb-0">
                  <h2>Analyzing posts from</h2>
                  <p class="my-2">
                    {{ this.dateTo }} - {{ this.dateFrom }}, {{ this.dateYear }}
                  </p>
                  <v-chip color="primary" dark
                    >Previous 30 days comparison</v-chip
                  >
                </v-col>
                <v-col
                  v-if="this.$store.state.user.userType == 'AA' &&  this.packageType != 'CompEatPaid' || this.$store.state.user.userType == 'SMM' && this.packageType != 'CompEatPaid' || this.$store.state.user.userType == 'SB' && this.packageType == 'CompEatPaid'"
                  cols="2"
                  class="text-right"
                >
                  <v-btn
                    :loading="loading"
                    :disabled="this.selectedReport.regenerated == 1"
                    class="primary hidden-md-and-down"
                    rounded
                    small
                    @click="createReport()"
                    >Regenerate</v-btn
                  >
                </v-col>
                <v-col cols="12">
                  <v-divider class="my-3"></v-divider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="10" sm="10" md="6" lg="6">
                  <v-text-field
                    rounded
                    outlined
                    dense
                    v-model="search"
                    label="Search Page Name"
                  ></v-text-field>
                </v-col>
                <!-- <v-col cols="3">
                                        <v-btn v-if="this.sorting != ''" @click="resetFilter()"  fab
                                                    small rounded color="primary" class="ml-2"> <v-icon>mdi-history</v-icon> </v-btn>
                                     </v-col> -->
                <v-col cols="2" sm="2" md="6" lg="6" class="text-right">
                  <v-btn
                    v-if="this.sorting != ''"
                    @click="resetFilter()"
                    fab
                    small
                    rounded
                    color="secondary"
                    class="mr-2"
                  >
                    <v-icon>mdi-history</v-icon>
                  </v-btn>
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        v-bind="attrs"
                        v-on="on"
                        rounded
                        fab
                        small
                      >
                        <v-icon>mdi-filter-variant</v-icon>
                      </v-btn>
                    </template>
                    <v-list>
                      <v-list-item
                        v-for="(item, index) in items"
                        :key="index"
                        @click="sortData(item.action)"
                      >
                        <v-list-item-title>{{ item.text }}</v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                </v-col>
              </v-row>
              <v-divider class="mb-3"></v-divider>
              <v-row>
                <v-col class="postsbox" cols="12">
                  <v-card
                    min-width="300px"
                    max-width="300px"
                    v-for="item in filteredData"
                    :key="item.id"
                    class="py-4 px-4 mx-2"
                  >
                    <v-row justify="center" align="center">
                      <v-col cols="3" class="text-center">
                        <v-avatar>
                          <img
                            :src="item.facebookPageData.picture.data.url"
                            alt="John"
                          />
                        </v-avatar>
                      </v-col>
                      <v-col cols="9">
                        <h2 class="posttitle">
                          {{ item.facebookPageData.name }}
                        </h2>
                        <!-- <p class="mb-0"> {{ item.facebookPageData.fan_count }}</p> -->
                      </v-col>
                      <v-col cols="12" class="text-center py-0">
                        <h1>
                          {{
                            item.analysisOfPosts.engagement_per_post
                              | formattedTwoDecimals
                          }}
                        </h1>
                        <p class="mb-1">Engagement Per Post</p>
                        <v-divider></v-divider>
                      </v-col>
                      <v-col cols="6" class="text-center">
                        <h3 class="mb-0 font-weight-black">
                          {{
                            item.facebookPageData.fan_count | formattedToMilOrK
                          }}
                        </h3>
                        <p class="mb-0">Audience</p>
                      </v-col>
                      <v-col cols="6" class="text-center mb-0">
                        <h3 class="mb-0 font-weight-black">
                          {{
                            item.analysisOfPosts.posts_per_week
                              | formattedTwoDecimals
                          }}
                        </h3>
                        <p class="mb-0">Post Per Week</p>
                      </v-col>
                      <v-col cols="12">
                        <v-card
                          height="660px"
                          v-for="item in item.topTwoPosts"
                          :key="item.id"
                          class="py-3 px-3 my-2 cardsradius"
                        >
                          <v-img
                            class="white--text align-end"
                            height="200px"
                            :src="item.media_url"
                            :lazy-src="item.media_url"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="grey lighten-5"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-row>
                            <v-col cols="12 pb-0 mt-2 postcontent">
                              {{ item.content }}
                              <v-divider class="mt-2"></v-divider>
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.likes }}</p>
                              <v-img
                                src="../assets/like.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.love }}</p>
                              <v-img
                                src="../assets/love.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.wow }}</p>
                              <v-img
                                src="../assets/wow.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.sad }}</p>
                              <v-img
                                src="../assets/sad.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.haha }}</p>
                              <v-img
                                src="../assets/haha.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="2" class="text-center px-1">
                              <p class="mb-0 reactiontext">{{ item.angry }}</p>
                              <v-img
                                src="../assets/angry.png"
                                width="25px"
                                class="mx-auto"
                              />
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="text-center my-2">
                              <v-icon color="primary">mdi-share-variant</v-icon>
                              Shares {{ item.shares }}
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="text-center my-2">
                              <v-icon color="primary">mdi-sticker-emoji</v-icon>
                              Total Reactions {{ item.reactions }}
                            </v-col>
                            <v-col cols="12" class="py-0">
                              <v-divider></v-divider>
                            </v-col>
                            <v-col cols="12" class="text-center">
                              <v-btn
                                rounded
                                color="primary"
                                :href="item.permalink_url"
                                target="_blank"
                              >
                                View Post
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-col>
              </v-row>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>ACTIVITY</h1>
            <p>
              Measure the activity and effectiveness of your social media
              campaigns to gauge how well your audience is engaging with your
              posts.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6">
            <h1>Daily Posts</h1>
            <p>
              By posting multiple times a day you get more opportunities to get
              your brand in front of your audience. Find the balance between
              being heard and less-being more with statistics about your daily
              posts.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.average_daily_posts
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="averageDailyPosts"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Days Per Week With Posts</h1>
            <p>
              Stay relevant, consistent, authoritative and at the forefront of
              your audience’s attention by posting regularly!
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.days_per_week_with_post
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="daysPerWeekWithPosts"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Percentage of Posts with Links</h1>
            <p>
              Give your viewers a reason to stop scrolling for a moment by
              getting them to engage more meaningfully with your posts. You can
              do this by creating content that is interesting and helpful to the
              viewer.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.percent_post_with_links
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="percentagePostLinks"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Engagment</h1>
            <p>
              Spot the elements in your posts that encourage your viewers to act
              and interact meaningfully with your brand.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6">
            <h1>Engagement Total per Post</h1>
            <p>
              You want as many reactions, comments, and shares as possible for
              each post. Remember, that more engagement means more people will
              be seeing your content and interacting with your brand.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.engagement_per_post
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="engagmentTotalPerPost"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Engagement Rate</h1>
            <p>
              Engagement Rates offer a measure of how excited your audience is
              about your content, by quantifying how meaningfully they interact
              with them according to the ratio of your followers.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.engagement_rate
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="engagmentRate"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>

          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12" class="my-6">
            <h1>Shares Per Post</h1>
            <p>
              Shared posts get you more coverage and gets your message out
              further. The more shares you get, the more your brand will
              resonate through the market.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.analysisOfPosts.shares_per_post
                        | formattedTwoDecimals
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="sharesPerPost"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div class="lightgrey">
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6 text-center">
            <h1>Audience</h1>
            <p>
              Find out who is behind the likes and comments that get your brand
              known. Find out who they are, how they behave, and which posts
              they are interacting most with.
            </p>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div>
      <v-container>
        <v-row>
          <v-col cols="12" class="my-6">
            <h1>Audience</h1>
            <p>
              Find out who is behind the likes and comments that get your brand
              known. Find out who they are, how they behave, and which posts
              they are interacting most with.
            </p>
          </v-col>
          <v-col cols="12" sm="12" md="7" lg="7">
            <v-list>
              <v-list-item-group color="primary">
                <v-list-item v-for="item in selectedReport.data" :key="item.id">
                  <v-list-item-icon>
                    <v-avatar>
                      <img
                        sizes="50"
                        :src="item.facebookPageData.picture.data.url"
                        alt="John"
                      />
                    </v-avatar>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      item.facebookPageData.name
                    }}</v-list-item-title>
                  </v-list-item-content>
                  <v-spacer></v-spacer>
                  <v-list-item-content class="text-right">
                    <v-list-item-title>{{
                      item.facebookPageData.fan_count | formattedToMilOrK
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-col>
          <v-col cols="12" sm="12" md="5" lg="5">
            <barChartVertical
              :height="height"
              :seriesInfo="audience"
              :facebookPageNameArray="facebookPageNameArray"
            />
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="120"
        >Please Wait...</v-progress-circular
      >
    </v-overlay>
    <v-overlay :value="redirecting">
      <v-progress-circular indeterminate size="120">
        <p class="mb-0 overlaytext">Please Wait <br />redirecting...</p>
      </v-progress-circular>
    </v-overlay>
    <v-overlay v-if="paymentResponseDialog">
      <!-- testing -->
      <v-card class="px-4 py-4 generatingreportcard" light>
        <v-card-text class="pt-5">
          <v-row v-if="paymentResponse == true">
            <v-col cols="12" class="text-center">
              <!-- mdi-emoticon-happy -->
              <v-avatar size="80px" class="compeatsecondary">
                <v-icon color="white" size="50px"> mdi-check-circle </v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="12" class="text-center">
              <h2 class="compeatsecondary--text compeatfont mb-3">
                Payment Was Successfull
              </h2>
              <p class="mb-0">Please wait...</p>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col cols="12" class="text-center">
              <!-- mdi-emoticon-happy -->
              <v-avatar size="80px" class="compeatsecondary">
                <v-icon color="white" size="50px"> mdi-alert-circle </v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="12" class="text-center">
              <h2 class="compeatsecondary--text compeatfont mb-3">
                Payment Was unsuccessfull
              </h2>
              <p class="mb-0">
                You did not complete the purchase or payment failed.
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-overlay v-if="displayContinue">
      <!-- testing -->
      <v-card class="px-4 py-4 generatingreportcard" light>
        <v-card-text class="pt-5">
          <v-row>
            <v-col cols="12" class="text-center">
              <!-- mdi-emoticon-happy -->
              <v-avatar size="80px" class="compeatsecondary">
                <v-icon color="white" size="50px"> mdi-check-circle </v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="12" class="text-center">
              <h2 class="compeatsecondary--text compeatfont mb-3">
                Thanks for your payment.
              </h2>
              <v-btn
                small
                class="primary py-3"
                rounded
                @click="goToDashboard()"
              >
                Go to Dashboard
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-overlay>
    <v-overlay v-if="displayCancelled">
      <!-- testing -->
      <v-card class="px-4 py-4 generatingreportcard" light>
        <v-card-text class="pt-5">
          <v-row>
            <v-col cols="12" class="text-center">
              <!-- mdi-emoticon-happy -->
              <v-avatar size="80px" class="compeatsecondary">
                <v-icon color="white" size="50px">mdi-alert-circle </v-icon>
              </v-avatar>
            </v-col>
            <v-col cols="12" class="text-center" v-if="!reason">
              <!-- reason -->
              <h2 class="compeatsecondary--text compeatfont mb-3">
                Payment Cancelled
              </h2>
              <p class="mb-0">
                We regret to inform you that your payment has been cancelled,
                thus preventing the continuation of your subscription purchase.
              </p>
              <p>
                If there is anything we can assist you with or if you require
                further assistance, please do not hesitate to contact our
                support team.
              </p>
            </v-col>
            <v-col cols="12" class="text-center" v-if="reason">
                <!-- reason -->
                <h2 class="compeatsecondary--text compeatfont mb-3">
                  Sorry To See You Go
                </h2>
                <p class="mb-0">
                  Your feedback is valuable to us as we strive to enhance our
                  service for all our subscribers.
                </p>
              </v-col>
              <v-col cols="12" sm="12" v-if="reason" class="text-center">
                <v-text-field
                  class="pt-0"
                  v-model="reasonForLeaving"
                  label="Reason (optional)"
                  :rules="textRules"
                ></v-text-field>
              </v-col>
            <v-col cols="12" class="text-center">
              <v-btn
                v-if="!reason"
                small
                class="primary py-3 mr-1"
                rounded
                @click="anotherTime()"
              >
                Another Time
              </v-btn>
              <v-btn
                small
                class="primary py-3 ml-1"
                rounded
                @click="proceedToCheckOut()"
                >Retry Payment</v-btn
              >
            </v-col>
            <v-col cols="12" v-if="reason" class="text-center">
                <v-btn 
                  small
                  class="primary py-3"
                  rounded
                  @click="cancelledSubscriptionPayment()"
                >
                 Continue
                </v-btn>
              </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import barChartVertical from "../components/charts/barChartVertical.vue";
import { firebaseApp } from "../firebaseConfig";
import {
  getFirestore,
  doc,
  getDoc,
  updateDoc,
  getDocs,
  collection,
  query,
  where,
  deleteField
} from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth, onAuthStateChanged } from "firebase/auth";
const db = getFirestore(firebaseApp);
import moment from "moment-timezone";

export default {
  props: ["id", "uid", "reportId"],
  components: {
    barChartVertical,
  },
  data: () => ({
    sorting: "",
    search: "",
    items: [
      { text: "Engagement Per Post", action: "engagement_per_post" },
      { text: "Audience", action: "fan_count" },
      { text: "Posts Per Week", action: "posts_per_week" },
    ],
    filterBy: "",
    selectedSubscription: [],
    selectedReport: [],
    dateFrom: "",
    dateTo: "",
    dateYear: "",
    daysPerWeekWithPosts: [],
    facebookPageNameArray: [],
    percentagePostLinks: [],
    engagmentTotalPerPost: [],
    engagmentRate: [],
    sharesPerPost: [],
    audience: [],
    averageDailyPosts: [],
    originalData: [],
    colsss: 4,
    overlay: false,
    isLoggedInUser: false,
    noUser: false,
    activeSubscription: false,
    pausedSubscription: false,
    cancelledSubscription: false,
    loading: false,
    pagesLength: 0,
    height: "",
    packageType: "",
    currentSubscriberId: "",
    checkOutLink: "",
    paymentResponse: false,
    paymentResponseDialog: false,
    redirecting: false,
    reason: "",
    displayContinue: false,
    displayCancelled: false,
    reasonForLeaving: "",
    textRules: [(v) => !!v || "Field is required"],
    giveTrial:false
  }),
  computed: {
    filteredData() {
      if (!this.selectedReport || !this.selectedReport.data) {
        return [];
      }
      // filter the data based on the search field
      return this.selectedReport.data.filter((item) =>
        item.facebookPageData.name
          .toLowerCase()
          .includes(this.search.toLowerCase())
      );
    },
  },
  filters: {
    formattedTwoDecimals(value) {
      return value.toFixed(2);
    },
    formattedToMilOrK(value) {
      const isMillion = Math.abs(value) >= 1e6;
      const isThousand = Math.abs(value) >= 1e3 && Math.abs(value) < 1e6;
      value = isMillion
        ? (value / 1e6).toFixed(2) + "M"
        : isThousand
        ? (value / 1e3).toFixed(2) + "K"
        : value.toFixed(2);
      return value.toLocaleString("en-US");
    },
  },
  created() {
    this.overlay = true;
    if (this.$store.state.checkOutLink != "") {
      this.getSubscription();
      setTimeout(() => {
        this.checkSuccess();
      }, 3000);
    } else {
      this.getCurrentUser();
    }
  },
  methods: {
    // gets the user or checks if no user
    getCurrentUser() {
      const auth = getAuth();
      onAuthStateChanged(auth, (user) => {
        if (user) {
          const getdata = async () => {
            const docRef = doc(db, "users", user.uid);
            const docSnap = await getDoc(docRef);
            let userRole = docSnap.data().userType;
            if (
              userRole == "SMM" ||
              userRole == "AA" ||
              userRole == "SB" ||
              userRole == "SA"
            ) {
              this.isLoggedInUser = true;
            }
          };
          getdata();
          this.getSubscription();
        } else {
          this.noUser = true;
          this.getSubscription();
        }
      });
    },
    // gets the subscription
    async getSubscription() {
      try {
        const docRef = doc(db, "subscriptions", this.uid); // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

        if (docSnapshot.exists()) {
          this.activeSubscription = true;
          this.selectedSubscription = docSnapshot.data();
          console.log("selectedSubscription", this.selectedSubscription);
          this.packageType = this.selectedSubscription.package.packageType;
          this.pagesLength = this.selectedSubscription.package.pages.length;

          if (this.pagesLength > 40) {
            this.height = "2000px";
          } else if (this.pagesLength > 30) {
            this.height = "1700px";
          } else if (this.pagesLength > 20) {
            this.height = "1300px";
          } else if (this.pagesLength > 10) {
            this.height = "900px";
          } else if (this.pagesLength > 5) {
            this.height = "400px";
          }
        } else {
          const cancelledSubscriptionDocRef = doc(
            db,
            "cancelledsubscriptions",
            this.uid
          );
          const cancelledSubscriptionSnapshot = await getDoc(
            cancelledSubscriptionDocRef
          );
          if (cancelledSubscriptionSnapshot.exists()) {
            this.cancelledSubscription = true;
            this.selectedSubscription = cancelledSubscriptionSnapshot.data();
          } else {
            const pausedSubscriptionDocRef = doc(
              db,
              "pausedsubscriptions",
              this.uid
            );
            const pausedSubscriptionSnapshot = await getDoc(
              pausedSubscriptionDocRef
            );
            if (pausedSubscriptionSnapshot.exists()) {
              this.pausedSubscription = true;
              this.selectedSubscription = pausedSubscriptionSnapshot.data();
            } else {
              this.overlay = false;
              throw new Error("Document not found");
            }
          }
        }
        this.getAllSubscriptions()
        // this.getReport();
      } catch (err) {
        console.log("err", err);
      }
    },
    async getAllSubscriptions(){
      let allSubscriptions = []
      const q = query(collection(db, "subscriptions"), where("subscriberId", "==", this.selectedSubscription.subscriberId));

      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        let subscription = doc.data()
        if(subscription.package.packageType != 'Compeat Demo Subscription'){
          allSubscriptions.push(subscription)
        }
      });

        // Additional collection query
      const q2 = query(collection(db, "cancelledsubscriptions"), where("subscriberId", "==", this.selectedSubscription.subscriberId));
      
      // Fetch additional collection documents
      const querySnapshot2 = await getDocs(q2);
      querySnapshot2.forEach((doc) => {
        let cancelledSubscription = doc.data();
        // Process the documents from the additional collection as needed
        if(cancelledSubscription.package.packageType != 'Compeat Demo Subscription'){
          allSubscriptions.push(cancelledSubscription)
        }
      });

      // Additional collection query
      const q3 = query(collection(db, "pausedsubscriptions"), where("subscriberId", "==", this.selectedSubscription.subscriberId));
      
      // Fetch additional collection documents
      const querySnapshot3 = await getDocs(q3);
      querySnapshot3.forEach((doc) => {
        let pausedSubscription = doc.data();
        // Process the documents from the additional collection as needed
        if(pausedSubscription.package.packageType != 'Compeat Demo Subscription'){
          allSubscriptions.push(pausedSubscription)
        }
      });

      if(allSubscriptions.length == 0){
        this.giveTrial = true
        console.log('trial')
      }
      this.getReport();
    },
    // gets the report
    async getReport() {
      try {
        const docRef = doc(db, "reports", this.reportId);
        // Use doc() to create a reference to the document
        const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot
        if (!docSnapshot.exists()) {
          throw new Error("Document not found");
        }
        this.selectedReport = docSnapshot.data();
        console.log("this.selectedReport", this.selectedReport);
        this.originalData = [...this.selectedReport.data];
        this.dateFrom = moment(this.selectedReport.createdAt).format("DD MMMM");
        this.dateTo = moment(this.selectedReport.createdAt)
          .subtract(30, "days")
          .format("DD MMMM");
        this.dateYear = moment(this.selectedReport.createdAt).format("YYYY");

        let postsPerWeekSeries = [];
        let percentagePostLinksSeries = [];
        let engagmentTotalPerPostSeries = [];
        let engagementRatesSeries = [];
        let sharesPerPostSeries = [];
        let audienceSeries = [];
        let averageDaliyPostSeries = [];
        let daysPerWeekWithPostSeries = [];

        this.selectedReport.data.forEach((obj) => {
          const postsPerWeek = obj.analysisOfPosts.posts_per_week;
          const daysPerWeekWithPost =
            obj.analysisOfPosts.days_per_week_with_post;
          const percentagePostWithLinks =
            obj.analysisOfPosts.percent_post_with_links;
          const engagmentPerPost = obj.analysisOfPosts.engagement_per_post;
          const engagmentRateAverage = obj.analysisOfPosts.engagement_rate;
          const sharesPerTopPosts = obj.analysisOfPosts.shares_per_post;
          const averDailyPost = obj.analysisOfPosts.average_daily_posts;

          const facebookPageName = obj.facebookPageData.name;
          const audienceTotal = obj.facebookPageData.fan_count;

          postsPerWeekSeries.push(postsPerWeek);
          daysPerWeekWithPostSeries.push(daysPerWeekWithPost);
          percentagePostLinksSeries.push(percentagePostWithLinks);
          engagmentTotalPerPostSeries.push(engagmentPerPost);
          engagementRatesSeries.push(engagmentRateAverage);
          sharesPerPostSeries.push(sharesPerTopPosts);
          averageDaliyPostSeries.push(averDailyPost);

          this.facebookPageNameArray.push(facebookPageName);
          audienceSeries.push(audienceTotal);
        });

        this.averageDailyPosts = {
          series: [
            {
              name: "Average daily posts",
              data: averageDaliyPostSeries,
            },
          ],
        };

        this.daysPerWeekWithPosts = {
          series: [
            {
              name: "Days per week with posts",
              data: daysPerWeekWithPostSeries,
            },
          ],
        };

        this.percentagePostLinks = {
          series: [
            {
              name: "Percentage of posts with links",
              data: percentagePostLinksSeries,
            },
          ],
        };

        this.engagmentTotalPerPost = {
          series: [
            {
              name: "Engagment total per post",
              data: engagmentTotalPerPostSeries,
            },
          ],
        };

        this.engagmentRate = {
          series: [
            {
              name: "Engagment Rate",
              data: engagementRatesSeries,
            },
          ],
        };

        this.sharesPerPost = {
          series: [
            {
              name: "Shares Per Post",
              data: sharesPerPostSeries,
            },
          ],
        };

        this.audience = {
          series: [
            {
              name: "Audience",
              data: audienceSeries,
            },
          ],
        };

        this.overlay = false;
      } catch (err) {
        console.log("err", err);
      }
    },
    // gets the email on the subscription and checks if the user exists
    async checkUser() {
      this.overlay = true;
      const q = query(
        collection(db, "users"),
        where("email", "==", this.selectedSubscription.email)
      );
      const querySnapshot = await getDocs(q);

      if (querySnapshot.empty == true) {
        console.log("New User needed to be created");
        this.newUser = true;
        this.$store.commit("setIfNewUser", this.newUser);
        this.createNewFirebaseUser();
      } else {
        console.log("Already A user exists");
        // this.newUser = false;
        querySnapshot.forEach(async (doc) => {
          this.newUser = false;
          this.$store.commit("setIfNewUser", this.newUser);
          this.currentSubscriberId = doc.data().id;
          console.log("this.currentSubscriberId", this.currentSubscriberId);
          if (this.currentSubscriberId) {
            this.updateSubscriptionWithNewUser();
          }
          // let user = {
          //   data: {
          //     userId: doc.data().id,
          //   },
          // };
          // console.log('this.currentSubscriberId', this.currentSubscriberId)
        });
      }
    },
    // Generate password for new Subscriber
    generateRandomPassword() {
      const length = 12;
      const charset =
        "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let newPassword = "";

      for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * charset.length);
        newPassword += charset.charAt(randomIndex);
      }

      this.password = newPassword;
      console.log("setNewUserPassword", this.password);
      this.$store.commit("setNewUserPassword", this.password);

      return this.password;
    },
    // Create New User in firebase if user doesnt exist
    createNewFirebaseUser() {
      const functions = getFunctions(firebaseApp, "europe-west2");
      const createSubscriptionUser = httpsCallable(
        functions,
        "createSubscriptionUser"
      );

      createSubscriptionUser({
        name: this.selectedSubscription.name,
        email: this.selectedSubscription.email,
        password: this.generateRandomPassword(),
        mobile: this.selectedSubscription.mobile,
        userType: "SB",
        agency: this.id,
        facebookToken: "",
      })
        .then((result) => {
          console.log("createSubscriptionUser.result", result);
          if (
            result.data.httpErrorCode != null &&
            result.data.httpErrorCode.status == 500
          ) {
            this.overlay = false;
            this.overlayError = true;
            this.catchErrorMessage = result.data.response.httpErrorCode.status;
          } else {
            this.currentSubscriberId = result.data.response.userId;
            console.log("this.currentSubscriber", this.currentSubscriberId);
            this.updateSubscriptionWithNewUser();
            // let user = {
            //   data: {
            //     userId: result.data.response.userId,
            //   },
            // };
            // this.createSubscription(user);
            // this.createSubscription(this.currentSubscriber);
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.overlay = false;
          this.overlayError = true;
          this.catchErrorMessage =
            error.message + " Please check all fields are correct";
        });
    },
    //update subscription user
    async updateSubscriptionWithNewUser() {
      try {
        const ref = doc(db, "subscriptions", this.uid);
        await updateDoc(ref, {
          subscriberId: this.currentSubscriberId,
        });
        if(this.$store.state.newUser == true){
            this.emailNewClientLogins()
        }
        console.log("User Created and Subscription Updated");
        this.getNewSubscriptionData();
      } catch (err) {
        console.log(err);
      }
    },
    async getNewSubscriptionData() {
      const docRef = doc(db, "subscriptions", this.uid); // Use doc() to create a reference to the document
      const docSnapshot = await getDoc(docRef); // Use getDoc() to retrieve the document snapshot

      if (docSnapshot.exists()) {
        this.activeSubscription = true;
        this.selectedSubscription = docSnapshot.data();
        console.log("selectedSubscription", this.selectedSubscription);
        this.packageType = this.selectedSubscription.package.packageType;
        this.pagesLength = this.selectedSubscription.package.pages.length;

        if (this.pagesLength > 40) {
          this.height = "2000px";
        } else if (this.pagesLength > 30) {
          this.height = "1700px";
        } else if (this.pagesLength > 20) {
          this.height = "1300px";
        } else if (this.pagesLength > 10) {
          this.height = "900px";
        } else if (this.pagesLength > 5) {
          this.height = "400px";
        }
        this.createPaypalSubscription();
        this.overlay = false;
        this.redirecting = true;
      }
    },
    //Generated the checkout page for paypal
    createPaypalSubscription() {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const paypalSubscription = httpsCallable(
          functions,
          "paypalSubscription"
        );

        paypalSubscription({
          packageTitle: this.selectedSubscription.package.currentPackage,
          plan_id: this.getPlanId(),
          quantity: this.selectedSubscription.package.quantity,
          subscriber: this.selectedSubscription.name,
          email: this.selectedSubscription.email,
          subscriptionUid: this.uid,
          agencyId: this.id,
          reportId: this.reportId,
          demoPurchase: true,
        }).then((result) => {
          this.overlay = false;
          this.checkOutLink =
            result.data.response.subscriptionData.links[0].href;
          this.$store.commit("setCheckOutLink", this.checkOutLink);
          window.location.href = this.checkOutLink;
          this.redirecting = false;
        });
      } catch (err) {
        console.log("err", err);
        this.overlay = false;
        this.overlayPaymentMethodError = true;
        this.catchErrorMessage = err.message;
      }
    },
    checkSuccess() {
      const queryString = this.$route.fullPath.split("?")[1];
      if (queryString) {
        const params = new URLSearchParams(queryString);
        const successValue = params.get("success");
        if (successValue === "true") {
          console.log("true", successValue);
          this.overlay = false;
          this.paymentResponse = true;
          this.paymentResponseDialog = true;
          this.updateSubscriptionWithPaymentResponse();
          // setTimeout(() => {
          //   this.paymentResponse = false;
          //   this.paymentResponseDialog = false;
          //   this.displayContinue = true
          // }, 3000);
          // console.log('true')
          //   return true;
        } else {
          this.overlay = false;
          this.paymentResponse = false;
          this.paymentResponseDialog = true;
          setTimeout(() => {
            this.paymentResponse = false;
            this.paymentResponseDialog = false;
            this.displayCancelled = true;
          }, 3000);
        }
      }
    },
    //update subscription user
    async updateSubscriptionWithPaymentResponse() {
      try {
        const ref = doc(db, "subscriptions", this.uid);
        await updateDoc(ref, {
          "package.packageType": "CompEatPaid",
          paymentStatus: "Paid",
        });
        console.log("User Created and Subscription Updated");
        setTimeout(() => {
          this.paymentResponse = false;
          this.paymentResponseDialog = false;
          this.displayContinue = true;
        }, 3000);
      } catch (err) {
        console.log(err);
      }
    },
    emailNewClientLogins() {
      try {
        // emailAdminUserLogins
        const functions = getFunctions(firebaseApp, "europe-west2");
        const emailAdminUserLogins = httpsCallable(
          functions,
          "emailAdminUserLogins"
        );

        emailAdminUserLogins({
          name: this.selectedSubscription.name,
          email: this.selectedSubscription.email,
          password: this.$store.state.newUserPassword,
        }).then((result) => {
          console.log("result", result);
        });
      } catch (err) {
        console.log("err", err);
        this.overlay = false;
        this.overlayPaymentMethodError = true;
        this.catchErrorMessage = err.message;
      }
    },
    // gets the package price for the subscription
    getPlanId() {
      const planIds = {
            "Package 1": {
                lessThanFive: "P-9E84088984609991YM3CGRQI",
                moreThanFive: "P-3CM416317M563321LM3CGSBY",
                trialLessThanFive: "P-2UW237251N140592LM3CGS3Y",
                trialMoreThanFive: "P-018867417T540491YM3CGTKY"
            },
            "Package 2": {
                normal: "P-72821967V3612203HM3CGUZY",
                trial: "P-01H639687J5467711M3CGUNY"
            },
            "Package 3": {
                lessThanFive: "P-2TW124804T652452EM3CGWJQ",
                moreThanFive: "P-9HU89873GY841201DM3CGXJY",
                trialLessThanFive: "P-3TN387101X4059634M3CILHQ",
                trialMoreThanFive: "P-74R92955LW7104535M3CGW7A"
            }
        };

      switch (this.selectedSubscription.package.currentPackage) {
        case "Package 1":
          if (this.selectedSubscription.package.pages.length <= 5 ) {
            if(this.giveTrial){
              console.log('trial 1')
              return planIds["Package 1"].trialLessThanFive;
            }else {
              console.log('package 1')
              return planIds["Package 1"].lessThanFive;
            }
          } 
        case "Package 2":
          if(this.giveTrial){
            console.log('trial 2')
            return planIds["Package 2"].trial
          }else {
            console.log('package 2')
            return planIds["Package 2"].normal
          }
        case "Package 3":
          if (this.selectedSubscription.package.pages.length < 5) {
            if(this.giveTrial){
              console.log('trial 3')
              return planIds["Package 3"].trialLessThanFive;
            }else {
              console.log('package 3')
              return planIds["Package 3"].lessThanFive;
            }
          } 
        default:
          return null; // Handle default case or return an error
      }
    },
    resetFilter() {
      this.selectedReport.data = [...this.originalData];
      this.sorting = "";
    },
    sortData(type) {
      // set the sorting type
      this.sorting = type;

      if (type === "fan_count") {
        // sort the facebookPageData array
        this.selectedReport.data.sort((a, b) => {
          if (a.facebookPageData[type] < b.facebookPageData[type]) {
            return 1;
          }
          if (a.facebookPageData[type] > b.facebookPageData[type]) {
            return -1;
          }
          return 0;
        });
      } else {
        // sort the selectedReport.data array
        this.selectedReport.data.sort((a, b) => {
          if (a.analysisOfPosts[type] < b.analysisOfPosts[type]) {
            return 1;
          }
          if (a.analysisOfPosts[type] > b.analysisOfPosts[type]) {
            return -1;
          }
          return 0;
        });
      }
    },
    backToSubscription() {
      if (this.activeSubscription == true) {
        this.$router.push({
          name: "singleSubscription",
          params: {
            uid: this.uid,
          },
        });
      } else if (this.cancelledSubscription == true) {
        this.$router.push({
          name: "singleCancelledSubscription",
          params: {
            uid: this.uid,
          },
        });
      } else if (this.pausedSubscription == true) {
        this.$router.push({
          name: "singlePausedSubscription",
          params: {
            uid: this.uid,
          },
        });
      }
    },
    // Create Competitive Analysis Report
    createReport() {
      this.loading = true;
      try {
        const pageIds = this.selectedSubscription.package.pages.map(
          (page) => page.id
        );

        const functions = getFunctions(firebaseApp, "europe-west2");
        const generateCompetitiveAnalysisReport = httpsCallable(
          functions,
          "generateCompetitiveAnalysisReport"
        );

        generateCompetitiveAnalysisReport({
          pageIds: pageIds,
          reportType: "regenerate",
        })
          .then((result) => {
            console.log('result', result)
            this.updateReportData(result.data.response);
            // this.competitiveReportUid = result.data.reportUid;
            // this.emailAdmins();
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    //Updates the report data with the new report data
    async updateReportData(data) {
      console.log('data', data)
      const reportRef = doc(db, "reports", this.reportId);

      await updateDoc(reportRef, {
        data: data,
        regenerated: 1,
        dateRegenerated: moment.now().valueOf(),
      });

      this.loading = false;

      let updateType = "newCompetitiveReport";

      this.emailUsers(updateType, data);
    },
    async emailUsers(updateType, data) {
      try {
        const functions = getFunctions(firebaseApp, "europe-west2");
        const emailPackageChange = httpsCallable(
          functions,
          "emailPackageChange"
        );

        emailPackageChange({
          subscription: this.selectedSubscription,
          packagePages: this.selectedSubscription.package.pages,
          updateType: updateType,
          packageTitle: this.selectedSubscription.package.currentPackage,
          primaryPage: this.selectedSubscription.package.pages[0],
          reportId: this.reportId,
        })
          .then((result) => {
            if (result.data.success == true) {
              this.getSubscription();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } catch (error) {
        console.log(error);
      }
    },
    goToDashboard() {
      this.checkOutLink = "";
      this.newUser = false;
      this.password = "";
      this.$store.commit("setCheckOutLink", this.checkOutLink);
      this.$store.commit("setIfNewUser", this.newUser);
      this.$store.commit("setNewUserPassword", this.password);
      this.$router.push({
        path: "/",
      });
    },
    //If client wants to check out again
    proceedToCheckOut() {
      this.displayCancelled = false;
      this.redirecting = true;
      setTimeout(() => {
        window.location.href = this.$store.state.checkOutLink;
        this.redirecting = false;
      }, 2000);
    },
    //If client cancels payment and diplay reason why
    anotherTime() {
      this.reason = true;
    },
    //Move the subscription to a cancelled payment collection
    async cancelledSubscriptionPayment() {
      this.displayCancelled = false;
      this.redirecting = true;
      try {
        const subscriptionDocRef = doc(db, "subscriptions", this.uid);

        // Update the document to remove paypalSubscriptionId
         await updateDoc(subscriptionDocRef, {
          reason:this.reason,
          paypalSubscriptionId: deleteField(),
        });

        this.checkOutLink = "";
        this.newUser = false;
        this.password = "";
        this.$store.commit("setCheckOutLink", this.checkOutLink);
        this.$store.commit("setIfNewUser", this.newUser);
        this.$store.commit("setNewUserPassword", this.password);
        if(this.$store.state.user != null){
          this.$router.push({
              path: "/",
            });
        }else {
          window.location.href = "https://compeat.social/contact/";
          this.redirecting = false;
        }
      } catch (err) {
        this.redirecting = false;
        console.error("Error deleting document:", err);
      }
    },
  },
};
</script>

<style>
.bg {
  background-color: #3d6eb1;
  height: 100%;
}

.lightgrey {
  background-color: #e3e3e3;
}

.reactiontext {
  font-size: 12px;
}

.postcontent {
  height: 180px;
  overflow: hidden;
}

.postsbox {
  display: flex;
  overflow-x: scroll;
}

.posttitle {
  height: 72px;
  overflow-y: hidden;
}
</style>
